import React, {Component} from 'react';
import {Row, Col, Button} from 'reactstrap';


class AddRemoveList extends Component
{
	constructor(props)
	{
		super(props);
		this.state = {};
	}

	/*Render code*/
	renderItems()
	{
		const len = this.props.items.length;
		let res = [];
		for(let i = 0; i < len; ++i)
		{
			res.push((
				<Row className='mt-2' style={{borderBottom: '3px solid rgba(0,0,0,.125)'}}>
					<Col>{this.props.renderItem(i)}</Col>
					<Col xs='auto'>
						<Button size='sm' color='danger' onClick={()=>this.props.onRemove(i)}>
							Obriši
						</Button>
					</Col>
				</Row>
					));
		}
		return res;
	}

	render()
	{
		return (
			<React.Fragment>
				<Row>
					<Col>
						{this.renderItems()}
					</Col>
				</Row>
				<Row className='mt-2'>
					<Col xs='auto'>
						<Button size='sm' color='primary' onClick={this.props.onAdd}>
							{this.props.buttonText ? this.props.buttonText : '+'}
						</Button>
					</Col>
				</Row>
			</React.Fragment>
		);
	}
}

export default AddRemoveList;
